import { render, staticRenderFns } from "./secondary-fee.vue?vue&type=template&id=e8c1e1da&scoped=true&"
import script from "./secondary-fee.vue?vue&type=script&lang=js&"
export * from "./secondary-fee.vue?vue&type=script&lang=js&"
import style0 from "./secondary-fee.vue?vue&type=style&index=0&id=e8c1e1da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c1e1da",
  null
  
)

export default component.exports